const REASON_TITLE_MAP =  {
	SHIPMENT_CONTRACT: 'refund of shipping costs',
	SHIPMENT_ANNEX_TO_THE_CONTRACT: 'refund of shipping costs',
	SHIPMENT_HEADPHONES: 'refund of shipping costs',
	SHIPMENT_TERMINATION_OF_THE_CONTRACT: 'refund of shipping costs',
	MEDICAL_CERTIFICATE: 'reimbursement for medical examinations',
	OTHER: 'other',
}


export const getPaymentTitle = (reason) => {
    if (REASON_TITLE_MAP[reason]) {
        return REASON_TITLE_MAP[reason];
    }

    throw new Error(`Unknown reason: ${reason}`);
};